<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col sm:w-full md:w-full d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h3 class="mb-4 text-center">Login</h3>
                </div>
                <vs-input v-validate="'required'" data-vv-as="Username" name="username" icon="icon icon-user" icon-pack="feather" v-model="username" class="w-full no-icon-border" placeholder="Username" />
                <span class="text-danger text-sm">{{ errors.first('username') }}</span>
                <vs-input v-validate="'required'" data-vv-as="Password" type="password" name="password" icon="icon icon-lock" icon-pack="feather" v-model="password" class="w-full mt-4 no-icon-border" placeholder="Password" />
                <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                <div class="my-4">
                  <vs-button class="vs-xs-12 float-right mb-5 w-full" color="success" @click="login">Login</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import auth from "@/services/authService"
import { Validator } from 'vee-validate';

import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  data() {
    return {
      username: '',
      email: '',
      password: '',
      remember_me: false
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.username != '' && this.password != '';
    },
  },
  methods: {
    async login() {

      try {

        const valid = await this.$validator.validate()
        if(!valid) {
          return
        }

        const email = this.username+'@'+process.env.VUE_APP_DOMAIN
        if(!process.env.VUE_APP_ADMIN_AUTH.split(',').includes(email)) {
          throw new Error()
        }

        await firebase.auth().signInWithEmailAndPassword(email, this.password)

        await auth.saveLogin()

        this.$vs.notify({
          title: 'เข้าสู่ระบบสำเร็จ',
          text: 'กรุณารอซักครู่...',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        });

        setTimeout(()=>{
          location.reload(true)
        }, 1000)
      }
      catch(e) {
        console.log(e)
        this.$vs.notify({
          title: 'เข้าสู่ระบบไม่สำเร็จ',
          text: e.message || 'ข้อมูลไม่ถูกต้อง',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }
    }
  },
  mounted() {
    Validator.localize('th', {
      custom: {
        email: {
          required: 'Username is required'
        }
      }
    });
  }
}
</script>
<style lang="scss">
#page-login {
  background-image: none;
  background-color: #5D0000;

  .social-login {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285F4;
    }

    .bg-github {
      background-color: #333;
    }
  }

  .vs-input--placeholder {
    font-size: 1rem;
  }

  .isFocus {
    .vs-input--placeholder.normal {
      padding: 0.2rem !important;
      padding-left: 3rem !important;
    }
  }
}

</style>
